<script setup lang="ts">
import { banner } from '~/components/widget/faq-page/filter/mocks'
import { WidgetFaqPageBanner, WidgetFaqPageFilter } from '~/components/widget/faq-page'
import { WidgetFaqLikeListMeiliSearch } from '~/components/widget/faq-like/list'
import type { IFaqQueryParams } from '~/components/widget/faq-list/types'

const selectedCategories = ref<string[]>([])

const route = useRoute()

const searchQuery = ref(typeof route.query.q === 'string' ? route.query.q : '')

const queryParams = reactive<IFaqQueryParams>({
  per_page: '20',
  filter: [],
  q: ''
})

watch(
  selectedCategories,
  (newCategories) => {
    if (newCategories.length === 0) {
      queryParams.filter = []
    } else {
      queryParams.filter = newCategories.map((category) => `categories.${category} = true`)
    }
  },
  { immediate: true }
)

watch(
  searchQuery,
  (q) => {
    queryParams.q = q.trim()
  },
  { immediate: true }
)
</script>

<template>
  <div class="space-y-5" role="main">
    <section class="rounded-lg bg-blue-50 py-6 md:bg-white md:py-10">
      <div class="mx-auto px-6">
        <div class="grid grid-cols-1 gap-4 lg:grid-cols-12">
          <div class="lg:col-span-8 lg:col-start-3">
            <div class="md:mb-6">
              <WidgetFaqPageFilter
                v-model:selected-categories="selectedCategories"
                v-model:search-query="searchQuery"
              />
            </div>
            <WidgetFaqPageBanner
              v-if="!$device.isMobile"
              :heading="banner.heading"
              :text="banner.text"
              :link-url="banner.linkUrl"
              :link-text="banner.linkText"
            />
          </div>
        </div>
      </div>
    </section>
    <WidgetFaqLikeListMeiliSearch search-type="faq" :query-params="queryParams" />
  </div>
</template>
